import PropTypes from 'prop-types';
import React from 'react';
import { DatePicker } from 'antd';
import { useSelector } from 'react-redux';
import moment from 'utils/cops-moment';
import styled from 'styled-components';

const StyledDatePicker = styled(DatePicker)`
  padding: 0 8px !important;
  input {
    font-weight: 400;
    font-size: 16px;
    height: 28px;
  }
`;

const CustomDatePicker = ({ allowPast = true, format = 'L', useBodyAsParent, ...rest }) => {
  const { fullScreen } = useSelector(state => state.planningBoard);
  const dateToday = moment().startOf('day');
  return (
    <StyledDatePicker
      allowClear={false}
      format={format}
      getPopupContainer={triggerNode => useBodyAsParent && !fullScreen ?
        document.body :
        triggerNode.parentNode
      }
      disabledDate={
        pickerDate =>
          allowPast ? false : dateToday?.diff(pickerDate) > 0
      }
      {...rest}
    />
  );
};

export default CustomDatePicker;

CustomDatePicker.propTypes = {
  allowPast: PropTypes.bool,
  format: PropTypes.string,
  useBodyAsParent: PropTypes.bool,
};
